import { render, staticRenderFns } from "./AllGamesView.vue?vue&type=template&id=2774fe54&scoped=true"
import script from "./AllGamesView.vue?vue&type=script&lang=js"
export * from "./AllGamesView.vue?vue&type=script&lang=js"
import style0 from "./AllGamesView.vue?vue&type=style&index=0&id=2774fe54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2774fe54",
  null
  
)

export default component.exports